// extracted by mini-css-extract-plugin
export default {"filterCards":"LiveScoreFilters_filterCards__cN7Ms","active":"LiveScoreFilters_active__71XLm","marginB":"LiveScoreFilters_marginB__Am24C"};